import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import 'hammerjs';

if (environment.production) {
  enableProdMode();
  // Disable console methods in production
  console.log = () => {};
}

platformBrowserDynamic().bootstrapModule(AppModule).then(() => {
  const appRoot = document.querySelector('[ng-version]');
  appRoot && appRoot.removeAttribute('ng-version');
}).catch(err => console.error(err));
